








import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'AppLoader',
})
export default class AppLoader extends Vue {}
